interface OnWheelCanvasUpdateProps {
  entries: any[];
  newColors: any[];
  setWinnerInfo: (winnerInfo: any) => void;
  lastWinnerIndexRef?: { current: number };
}

export const onWheelCanvasUpdate = (e: any, props?: OnWheelCanvasUpdateProps) => {
  if (!props?.entries.length) return;

  const pi = Math.PI;
  const oneFullRotation = 2 * pi;
  const angleInRadians = (e.rotate * pi) / 180;
  const index = (Math.ceil((angleInRadians / oneFullRotation) * props.entries.length) % props.entries.length);

  // Only update state when the wheel moves into a new sector
  if (props.lastWinnerIndexRef && props.lastWinnerIndexRef.current === index) return;
  if (props.lastWinnerIndexRef) props.lastWinnerIndexRef.current = index;

  const winIndex = index === 0 ? 0 : (props.entries.length - index) % props.newColors.length;
  props.setWinnerInfo({
    id: props.entries[(props.entries.length - index) % props.entries.length].id,
    value: props.entries[(props.entries.length - index) % props.entries.length].body,
    color: props.newColors[winIndex],
  });
};
